"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = {
    green: "#409a45",
    lightGreen: "#95cc9c",
    veryLightGreen: "#d2f9de",
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29sb3JzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQ2EsUUFBQSxNQUFNLEdBQUc7SUFDcEIsS0FBSyxFQUFFLFNBQVM7SUFDaEIsVUFBVSxFQUFFLFNBQVM7SUFDckIsY0FBYyxFQUFFLFNBQVM7Q0FDMUIsQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbIlxuZXhwb3J0IGNvbnN0IGNvbG9ycyA9IHtcbiAgZ3JlZW46IFwiIzQwOWE0NVwiLFxuICBsaWdodEdyZWVuOiBcIiM5NWNjOWNcIixcbiAgdmVyeUxpZ2h0R3JlZW46IFwiI2QyZjlkZVwiLFxufSJdfQ==